import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.span(
  ({ theme }) => `
  align-items: center;
  background: #FFF5FA; // unknown color in the designs
  border-radius: ${rem(8)};
  color: ${theme.palette.common.black};
  container: artifact-viewer-card / inline-size;
  display: flex;
  gap: ${rem(20)};
  margin: ${rem(16)} 0;
  padding: ${rem(16)};
  width: 100%;
  align-items: flex-start;
 
`
);

const IconWrapper = styled.span`
  display: flex;
  flex: 0 0 auto;

  svg {
    height: ${rem(32)};
    width: ${rem(32)};
  }
`;

const Content = styled.span`
  align-items: center;
  display: flex;
  flex: 1;
  gap: ${rem(16)};
  justify-content: space-between;
  min-width: 0;

  @container artifact-viewer-card (max-width: ${rem(600)}) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

const Text = styled.span`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
  min-width: 0;
`;

const Label = styled.span`
  color: inherit;
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(16)};
`;

const Title = styled.span`
  color: inherit;
  font-size: ${rem(16)};
  font-weight: 600;
  line-height: ${rem(20)};
`;

const Button = styled.button(
  ({ theme }) => `
  align-items: center;
  background: ${theme.palette.primary.main};
  border: none;
  border-radius: ${rem(4)};
  color: ${theme.palette.common.white};
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: ${rem(14)};
  font-weight: 600;
  gap: ${rem(6)};
  justify-content: center;
  line-height: ${rem(16)};
  padding: ${rem(8)} ${rem(12)};
  transition: background 100ms ease, scale 100ms ease;
  white-space: nowrap;

  &:hover {
    background: ${theme.palette.primary.dark};
  }

  &:active {
    scale: 0.98;
  }
`
);

const EyeIcon = styled.span`
  border: ${rem(1.8)} solid currentColor;
  border-radius: 999px / 700px;
  display: inline-block;
  height: ${rem(11)};
  position: relative;
  width: ${rem(16)};

  &::after {
    background: currentColor;
    border-radius: 50%;
    content: '';
    height: ${rem(4)};
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: ${rem(4)};
  }
`;

export default {
  Button,
  Content,
  EyeIcon,
  IconWrapper,
  Label,
  Text,
  Title,
  Wrapper
};
